import { useEffect, useState } from "react";

export default function useAuthenticatedObjectUrl(loader, dependencies = []) {
  const identity = JSON.stringify([dependencies, Boolean(loader)]);
  const [result, setResult] = useState({ identity: null, url: null, error: null, loading: false });

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    if (!loader) {
      setResult({ identity, url: null, error: null, loading: false });
      return () => { active = false; };
    }
    setResult({ identity, url: null, error: null, loading: true });
    Promise.resolve()
      .then(loader)
      .then(blob => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setResult({ identity, url: objectUrl, error: null, loading: false });
      })
      .catch(value => {
        if (active) setResult({ identity, url: null, error: value, loading: false });
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
    // Callers provide the stable identity of the requested resource.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // The supplied dependencies define resource identity; loaders are commonly inline callbacks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identity]);

  // Hide the previous resource immediately during the render before the new effect runs.
  return result.identity === identity
    ? { url: result.url, error: result.error, loading: result.loading }
    : { url: null, error: null, loading: Boolean(loader) };
}
